import { productTypeOption } from "data/constant/delivery-log";

export const initialFilterState = () => {
  return {
    dateType: "shift",
    startDate: null,
    endDate: null,
    searchKey: "",
    searchType: "deliveryId",
    order: "desc",
    productType: {
      isSelectedAll: true,
      value: productTypeOption.map((option) => option.value),
    },
    page: 1,
    perPage: 10,
  };
};
